// src/pages/Monitoramento.js

import React, { useEffect, useState } from "react";
import AdminLayout from "../components/AdminLayout";
import DataTableMonitoramento from "../components/DataTableMonitoramento";
import axios from "axios";

function Monitoramento() {
  axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get("monitoramento/")
      .then(response => {
        setData(response.data);
      })
      .catch(error => {
        console.error("Erro ao buscar dados do monitoramento:", error);
      });
  }, []);

  return (
    <AdminLayout>
        <DataTableMonitoramento
          title="Monitoramento"
          newButtonRoute="./novo"
          data={data}
        />
    </AdminLayout>
  );
}

export default Monitoramento;